import firebase from 'firebase/app'

import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

// var config = {
//   apiKey: "AIzaSyAGlJCceJGfAqkjM3Dd_uHx5eEcf6-yif0",
//   authDomain: "bidcom-34469.firebaseapp.com",
//   projectId: "bidcom-34469",
//   storageBucket: "bidcom-34469.appspot.com",
//   messagingSenderId: "339617476173",
//   appId: "1:339617476173:web:99b1bc31ab346ca5cc3604",
//   measurementId: "G-SWV3KFK6PV"
// };

const config = {
  apiKey: "AIzaSyBvfdCSL8JV8xouMfns1pHDLaOr29LoR0Y",
  authDomain: "livestock-dev-6f4fe.firebaseapp.com",
  projectId: "livestock-dev-6f4fe",
  storageBucket: "livestock-dev-6f4fe.appspot.com",
  messagingSenderId: "807884991928",
  appId: "1:807884991928:web:79dffaf59c282d6b6eb34d",
  measurementId: "G-K77MG4VLZ7"
};



if (!firebase.apps.length) {
  firebase.initializeApp(config);
}else {
  firebase.app(); // if already initialized, use that one
}
// alert(JSON.stringify(firebase.auth()))
console.log(firebase.auth())
var auth = firebase.auth();
var storage = firebase.storage();
var db = firebase.firestore();

export {
  db,
  auth,
  storage
};